import { PaperProps, Paper, Divider, DividerProps } from '@mui/material';
import React from 'react';
import { colors } from 'styles/colors';
import TypographyWithI18N, {
  TypographyWithI18NProps,
} from './TypographyWithI18N';

interface IWidgetProps extends PaperProps {
  dividerProps?: DividerProps;
  headingProps?: TypographyWithI18NProps;
  withDivider?: boolean;
}

const Widget: React.FC<IWidgetProps> = ({
  children,
  dividerProps,
  headingProps,
  id,
  withDivider,
  variant,
  ...props
}) => {
  const headingElemId = headingProps?.id || `${id}-heading`;
  const dividerElemId = dividerProps?.id || `${id}-divider`;
  return (
    <Paper
      id={id}
      data-testid={id}
      variant={variant}
      {...props}
      sx={{
        padding: ({ typography }) => `${typography.pxToRem(20)}`,
        borderRadius: ({ typography }) => `${typography.pxToRem(16)}`,
        background: colors.background.componentBackground,
        boxShadow:
          variant === 'elevation'
            ? '0 0.125rem 0.125rem rgba(0, 0, 0, 0.15)'
            : 'none',
        ...props.sx,
      }}
    >
      {headingProps?.i18nKey && (
        <TypographyWithI18N
          variant='h2'
          className='kfic2-bodyTextBold'
          {...headingProps}
          id={headingElemId}
          data-testid={headingElemId}
          sx={{
            fontWeight: `400`,
            ...headingProps?.sx,
          }}
        />
      )}
      {withDivider && (
        <Divider
          {...dividerProps}
          id={dividerElemId}
          data-testid={dividerElemId}
          sx={{
            mt: ({ typography }) => typography.pxToRem(8),
            mb: ({ typography }) => typography.pxToRem(0),
            ...dividerProps?.sx,
          }}
        />
      )}
      {children}
    </Paper>
  );
};

export default Widget;
